import { VisitorIdEventUserObject } from "./typeDefinitions";

export class VisitorIdEvent {
  event = 'visitorID ready' as const;
  user: VisitorIdEventUserObject;

  constructor(visitorId: string) {
    this.user = {
      visitorId
    }
  }
}